import {
  Accessibility,
  AccountBalanceTwoTone,
  AssignmentReturnTwoTone,
  CancelTwoTone,
  CreditCardOffTwoTone,
  CreditScoreTwoTone,
  CurrencyRupeeTwoTone,
  OpenWithTwoTone,
  ReceiptTwoTone,
} from "@mui/icons-material";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import ListItem from "@mui/material/ListItem";
import { styled } from "@mui/material/styles";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CovReducerAction } from "../Store/Cov/CovReducer";
import "./../Pagelayout/PageLayout.css";
import CovLoanDetailsScreenSelection from "./CovLoanDetailsScreenSelection";
import CustomerDetails from "./DetailPages/CustomerDetails";
import DisbursementDetails from "./DetailPages/DisbursementDetails";
import FeeChargesDetails from "./DetailPages/FeeChargesDetails";
import LoanDetails from "./DetailPages/LoanDetails";
import NachDetails from "./DetailPages/NachDetails";
import ReceiptDetails from "./DetailPages/ReceiptDetails";
import ReturnDetails from "./DetailPages/ReturnDetails";
import VoucherDetails from "./DetailPages/VoucherDetails";
import { useRef } from "react";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import { useEffect } from "react";
const drawerWidth = 240;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: "-40px",
    }),
  })
);

const CovDetailScreenContainer = (props) => {
  const [screenName, setScreenName] = useState(props.screenName);
  let content = {};
  const dispatch = useDispatch();

  //shortcut key
  const closeRef = useRef(null);

  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "covDetailScreen",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    if (event.ctrlKey) {
      if (charCode === "q") {
        closeRef.current.click();
      }
    }
  };

  switch (screenName) {
    case "Customer Details":
      content = (
        <>
          <CustomerDetails screenName={screenName} />
        </>
      );

      break;

    case "Loan Information":
      content = (
        <>
          <LoanDetails screenName={screenName} />
        </>
      );

      break;

    case "Disbursement Details":
      content = (
        <>
          <DisbursementDetails />
        </>
      );
      break;

    case "Fee & Other Charges":
      content = (
        <>
          <FeeChargesDetails />
        </>
      );
      break;

    case "NACH Details":
      content = (
        <>
          <NachDetails />
        </>
      );
      break;

    case "Voucher Details":
      content = (
        <>
          <VoucherDetails />
        </>
      );
      break;

    case "Receipt Details":
      content = (
        <>
          <ReceiptDetails />
        </>
      );
      break;

    case "Return Details":
      content = (
        <>
          <ReturnDetails />
        </>
      );
      break;
  }

  const [expandMenu, setExpandMenu] = useState(false);

  const screenSelection = useSelector((state) => state.cov.screenSelection);

  const CustomListItemButton = styled(ListItemButton)`
    &&.Mui-selected {
      background-color: #c7c9c8;
    }
  `;

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />

        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
            },
          }}
          variant="persistent"
          anchor="left"
          open={expandMenu}
        >
          <List sx={{ marginTop: "70px", marginLeft: "33px" }}>
            <>
              {screenSelection.right.includes("Loan Information") && (
                <>
                  <ListItem key={"loan"} disablePadding>
                    <CustomListItemButton
                      onClick={() => {
                        setScreenName("Loan Information");
                      }}
                      selected={
                        screenName === "Loan Information" ? true : false
                      }
                    >
                      <ListItemIcon>
                        <CreditScoreTwoTone />
                      </ListItemIcon>
                      <ListItemText
                        primary={"Loan Information"}
                        sx={{ marginLeft: "-30px" }}
                      />
                    </CustomListItemButton>
                  </ListItem>
                  <Divider />
                </>
              )}

              {screenSelection.right.includes("Disbursement Details") && (
                <>
                  <ListItem key={"disbursement"} disablePadding>
                    <CustomListItemButton
                      onClick={() => {
                        setScreenName("Disbursement Details");
                      }}
                      selected={
                        screenName === "Disbursement Details" ? true : false
                      }
                    >
                      <ListItemIcon>
                        <CurrencyRupeeTwoTone />
                      </ListItemIcon>
                      <ListItemText
                        primary={"Disbursement Details"}
                        sx={{ marginLeft: "-30px" }}
                      />
                    </CustomListItemButton>
                  </ListItem>
                  <Divider />
                </>
              )}

              {screenSelection.right.includes("Fee & Other Charges") &&
                props.dashboardData.outstandingAmount !== -1 && (
                  <>
                    <ListItem key={"fee"} disablePadding>
                      <CustomListItemButton
                        onClick={() => {
                          setScreenName("Fee & Other Charges");
                        }}
                        selected={
                          screenName === "Fee & Other Charges" ? true : false
                        }
                      >
                        <ListItemIcon>
                          <CreditCardOffTwoTone />
                        </ListItemIcon>
                        <ListItemText
                          primary={"Fee & Other Charges"}
                          sx={{ marginLeft: "-30px" }}
                        />
                      </CustomListItemButton>
                    </ListItem>
                    <Divider />
                  </>
                )}

              {screenSelection.right.includes("NACH Details") &&
                props.dashboardData.totalNachAmount !== -1 && (
                  <>
                    <ListItem key={"nach"} disablePadding>
                      <CustomListItemButton
                        onClick={() => {
                          setScreenName("NACH Details");
                        }}
                        selected={screenName === "NACH Details" ? true : false}
                      >
                        <ListItemIcon>
                          <AccountBalanceTwoTone />
                        </ListItemIcon>
                        <ListItemText
                          primary={"NACH Details"}
                          sx={{ marginLeft: "-30px" }}
                        />
                      </CustomListItemButton>
                    </ListItem>
                    <Divider />
                  </>
                )}

              {screenSelection.right.includes("Voucher Details") && (
                <>
                  <ListItem key={"voucher"} disablePadding>
                    <CustomListItemButton
                      onClick={() => {
                        setScreenName("Voucher Details");
                      }}
                      selected={screenName === "Voucher Details" ? true : false}
                    >
                      <ListItemIcon>
                        <InboxIcon />
                      </ListItemIcon>
                      <ListItemText
                        primary={"Voucher Details"}
                        sx={{ marginLeft: "-30px" }}
                      />
                    </CustomListItemButton>
                  </ListItem>
                  <Divider />
                </>
              )}

              {screenSelection.right.includes("Receipt Details") && (
                <>
                  <ListItem key={"receipt"} disablePadding>
                    <CustomListItemButton
                      onClick={() => {
                        setScreenName("Receipt Details");
                      }}
                      selected={screenName === "Receipt Details" ? true : false}
                    >
                      <ListItemIcon>
                        <ReceiptTwoTone />
                      </ListItemIcon>
                      <ListItemText
                        primary={"Receipt Details"}
                        sx={{ marginLeft: "-30px" }}
                      />
                    </CustomListItemButton>
                  </ListItem>
                  <Divider />
                </>
              )}

              {screenSelection.right.includes("Return Details") && (
                <>
                  <ListItem key={"return"} disablePadding>
                    <CustomListItemButton
                      onClick={() => {
                        setScreenName("Return Details");
                      }}
                      selected={screenName === "Return Details" ? true : false}
                    >
                      <ListItemIcon>
                        <AssignmentReturnTwoTone />
                      </ListItemIcon>
                      <ListItemText
                        primary={"Return Details"}
                        sx={{ marginLeft: "-30px" }}
                      />
                    </CustomListItemButton>
                  </ListItem>
                  <Divider />
                </>
              )}
            </>
          </List>
        </Drawer>

        <Main open={expandMenu}>
          <Drawer
            sx={{
              width: 45,
              flexShrink: 0,
              "& .MuiDrawer-paper": {
                width: 45,
                boxSizing: "border-box",
              },
            }}
            variant="persistent"
            anchor="left"
            open={true}
          >
            <List sx={{ marginTop: "70px" }}>
              <>
                <>
                  <ListItem key={"customer"} disablePadding>
                    <Tooltip title="Expand Details Menu">
                      <IconButton
                        aria-label="Expand Details Menu"
                        color="primary"
                        onClick={() => {
                          setExpandMenu(!expandMenu);
                        }}
                      >
                        <OpenWithTwoTone fontSize="large" />
                      </IconButton>
                    </Tooltip>
                  </ListItem>
                </>

                <>
                  <ListItem
                    key={"customer"}
                    disablePadding
                    sx={{ marginTop: "20px" }}
                  >
                    <Tooltip title="Close(Ctrl+Q)">
                      <IconButton
                        aria-label="Close"
                        color="primary"
                        onClick={() => {
                          props.setShowDetail(false);
                        }}
                        ref={closeRef}
                      >
                        <CancelTwoTone fontSize="large" />
                      </IconButton>
                    </Tooltip>
                  </ListItem>
                </>
              </>
            </List>
          </Drawer>

          <Box marginTop={"-2%"} marginLeft={"1%"} marginRight={"-2%"}>
            <h4>{screenName}</h4>
            {content}
          </Box>
        </Main>
      </Box>
      <Dialog
        onClose={() => {
          dispatch(CovReducerAction.updateshowScreenSelection(false));
        }}
        open={screenSelection.showScreenSelection}
        // maxWidth={"md"}
        sx={{ marginTop: "60px" }}
      >
        <DialogTitle>Screen Selection</DialogTitle>
        <DialogContent>
          <CovLoanDetailsScreenSelection />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CovDetailScreenContainer;
